module.exports = __webpack_public_path__ + "img/auto_spin_btn.4d2f88ec.png";